import { render, staticRenderFns } from "./ContentColumnList.vue?vue&type=template&id=ffcbf93e&scoped=true&"
import script from "./ContentColumnList.vue?vue&type=script&lang=js&"
export * from "./ContentColumnList.vue?vue&type=script&lang=js&"
import style0 from "./ContentColumnList.vue?vue&type=style&index=0&id=ffcbf93e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcbf93e",
  null
  
)

export default component.exports